module.exports = __webpack_public_path__ + "static/media/upload_more.1d8094f7.svg";